export default "__VITE_ASSET__d6833215__"